// Application-wide settings and configuration values
export const settings = {
  // Contact Information
  phone: {
    support: '(855) 303-1455',
    supportRaw: '8553031455'
  },
  
  // Business Hours (in PST/PDT)
  businessHours: {
    weekday: {
      start: 5, // 5 AM - used to determine whether we are "in business hours" (e.g. success page)
      schedulingStart: 4, // 4 AM - earliest slot shown in the call-back scheduler, matches API availability
      end: 19   // 7 PM
    },
    saturday: {
      start: 8, // 8 AM
      schedulingStart: 6, // 6 AM - earliest slot shown in the call-back scheduler, matches API availability
      end: 17   // 5 PM
    },
    sunday: {
      start: 8, // 8 AM
      end: 17   // 5 PM
    }
  }
} as const;